import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createElementBlock as _createElementBlock, createElementVNode as _createElementVNode, withCtx as _withCtx, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { class: "TUIKit-main-container" }
const _hoisted_2 = {
  key: 0,
  class: "TUIKit-main"
}
const _hoisted_3 = {
  key: 0,
  class: "TUIKit-main-aside"
}
const _hoisted_4 = {
  key: 1,
  class: "TUIKit-main-main"
}
const _hoisted_5 = {
  key: 1,
  class: "TUIKit-main"
}

import { ref, onMounted, onUnmounted, framework } from './adapter-vue';
import { TUILogin } from '@tencentcloud/tui-core';
import {
  TUIStore,
  StoreName,
  TUIConversationService,
} from '@tencentcloud/chat-uikit-engine';
import {
  TUISearch,
  TUIConversation,
  TUIChat,
  TUIContact,
  TUIGroup,
} from './components';
import { isH5 } from './utils/env';
import { isPostMessageSenderOriginAllowed } from '@/utils/post_message_security';


export default /*@__PURE__*/_defineComponent({
  __name: 'index',
  props: {
  // When deploying a production environment, you do not need to pass in SDKAppID, userID, and userSig through props.
  // eslint-disable-next-line vue/prop-name-casing
  SDKAppID: {
    type: Number,
    default: 0,
    required: false,
  },
  userID: {
    type: String,
    default: '',
    required: false,
  },
  userSig: {
    type: String,
    default: '',
    required: false,
  },
  conversationID: {
    type: String,
    default: '',
    required: false, // When integrating Chat independently, you need to pass the conversationID
  },
},
  emits: ['loginStateChange'],
  setup(__props, { expose: __expose, emit: __emit }) {

const currentConversationID = ref<string>('');
const currentNavbar = ref<string>('conversation');
const atConversationList = ref<any[]>([]);
const allConversationList = ref<any[]>([]);
const TUIChatRef = ref<InstanceType<typeof TUIChatRef>>();
const navbarList = [
  {
    id: 'conversation',
    label: '会话',
  },
  {
    id: 'contact',
    label: '通讯录',
  },
];
let parentOrigin: string | null = null;
const props = __props;
const emits = __emit;
let isUnmounted = false;

function onCurrentConversationIDUpdated(id: string): void {
  currentConversationID.value = id;
}

onMounted(() => {
  TUIStore.watch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
  });

  // Default login logic
  login();

  // Modify CallKit style in H5 environment
  modifyCallKitStyle();
  window.addEventListener('message', handleToUserMessage);
  window.addEventListener('beforeunload', sendMessage);
});

onUnmounted(() => {
  isUnmounted = true;
  TUIStore.unwatch(StoreName.CONV, {
    currentConversationID: onCurrentConversationIDUpdated,
  });
  window.removeEventListener('message', handleToUserMessage);
  window.removeEventListener('beforeunload', sendMessage);
});

function handleToUserMessage(event: MessageEvent) {
  if (!isPostMessageSenderOriginAllowed(event.origin)) {
    return;
  }
  const payload = event.data;
  if (payload === null || typeof payload !== 'object' || Array.isArray(payload)) {
    return;
  }
  if (typeof (payload as Record<string, unknown>).toUser === 'string' && event.origin) {
    parentOrigin = event.origin;
  }
}

function sendMessage() {
  if (parentOrigin && window.opener) {
    window.opener.postMessage(
      { key: 'PAGE_CLOSED' },
      parentOrigin
    );
  }
}

function saveAllConversationList(conversationList: any) {
  allConversationList.value = conversationList;
}
function saveAtConversationList(conversationList: any) {
  atConversationList.value = conversationList;
}
function clearChatInput() {
  TUIChatRef?.value?.clearInput();
}
function login() {
  const { SDKAppID, userID, userSig, conversationID } = props;
  if (SDKAppID && userID && userSig) {
    emits('loginStateChange', 'loading');
    return Promise.resolve().then(() => TUILogin.login({
      SDKAppID,
      userID,
      userSig,
      useUploadPlugin: true,
      framework,
    }))
      .then(() => {
        if (isUnmounted) return;
        emits('loginStateChange', 'ready');
        if (
          conversationID.startsWith('C2C') ||
          conversationID.startsWith('GROUP')
        ) {
          void Promise.resolve(
            TUIConversationService.switchConversation(conversationID)
          ).catch(() => {});
        }
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
      })
      .catch(() => {
        if (!isUnmounted) emits('loginStateChange', 'error');
      });
  }
}

__expose({ login });

function modifyCallKitStyle() {
  if (isH5) {
    const bodyStyle = document.getElementsByTagName('body')[0].style;
    bodyStyle.setProperty('--callLeft', '0');
    bodyStyle.setProperty('--callTop', '0');
    bodyStyle.setProperty('--callWidth', '100%');
    bodyStyle.setProperty('--callHeight', '100%');
  }
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", null, [
    _renderSlot(_ctx.$slots, "default", {}, () => [
      _createElementVNode("div", {
        class: _normalizeClass(['TUIKit', _unref(isH5) && 'TUIKit-h5'])
      }, [
        _createElementVNode("div", _hoisted_1, [
          (_unref(currentNavbar) === 'conversation')
            ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                (!(_unref(isH5) && _unref(currentConversationID)))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
                      (_unref(allConversationList).length > 0)
                        ? (_openBlock(), _createBlock(_unref(TUISearch), {
                            key: 0,
                            searchType: "global",
                            allConversationList: _unref(allConversationList)
                          }, null, 8, ["allConversationList"]))
                        : _createCommentVNode("", true),
                      _createVNode(_unref(TUIConversation), {
                        onSaveAtConversationList: saveAtConversationList,
                        onSaveAllConversationList: saveAllConversationList,
                        onClearChatInput: clearChatInput
                      })
                    ]))
                  : _createCommentVNode("", true),
                (!_unref(isH5) || _unref(currentConversationID))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_4, [
                      _createVNode(_unref(TUIChat), {
                        ref_key: "TUIChatRef",
                        ref: TUIChatRef,
                        atConversationList: _unref(atConversationList)
                      }, {
                        default: _withCtx(() => [...(_cache[1] || (_cache[1] = [
                          _createElementVNode("p", { class: "chat-empty" }, "请选择左侧会话，或从业务平台发起聊天。", -1)
                        ]))]),
                        _: 1
                      }, 8, ["atConversationList"]),
                      _createVNode(_unref(TUIGroup), {
                        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside')
                      }, null, 8, ["class"]),
                      _createVNode(_unref(TUISearch), {
                        class: _normalizeClass(_unref(isH5) ? 'chat-popup' : 'chat-aside'),
                        searchType: "conversation",
                        allConversationList: _unref(allConversationList)
                      }, null, 8, ["class", "allConversationList"])
                    ]))
                  : _createCommentVNode("", true),
                (_unref(isH5) && !_unref(currentConversationID))
                  ? (_openBlock(), _createBlock(_unref(TUIGroup), {
                      key: 2,
                      class: "chat-popup"
                    }))
                  : _createCommentVNode("", true),
                _createVNode(_unref(TUIContact), { displayType: "selectFriend" })
              ]))
            : (_unref(currentNavbar) === 'contact')
              ? (_openBlock(), _createElementBlock("div", _hoisted_5, [
                  _createVNode(_unref(TUIContact), {
                    displayType: "contactList",
                    onSwitchConversation: _cache[0] || (_cache[0] = ($event: any) => (currentNavbar.value = 'conversation'))
                  })
                ]))
              : _createCommentVNode("", true)
        ])
      ], 2)
    ])
  ]))
}
}

})